import { Operation } from "../operation.js";

export class Filter extends Operation {
    _layerVisible: boolean;

    constructor(gl: any, width: number, height: number, program: string, name: string) {
        super(gl, width, height, program, name);
        this._type = 'FILTER';
        this._layerVisible = true;
    }

    get layerVisible() {
        return this._layerVisible;
    }

}
